<ion-header no-border>
  <app-close-button (onClicked)="cancel()" [isModal]="true"></app-close-button>
</ion-header>

<ion-content class="custom-inputs">
  <div class="medium">
    <div class="page-title">{{title}}</div>
    <form id="folderAddForm" name="folderAddForm"></form>
    <form id="folderEditForm" name="folderEditForm"></form>
  </div>
</ion-content>
